import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HttpService } from '../../../core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { environment } from '../../../../environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import $ from 'jquery'

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss']
})

export class EditUserDialogComponent implements OnInit {
  reactiveForm: any;
  selectedFile: any;
  userId: any;
  companyId: any;
  user: any;
  SERVER_URL = environment.SERVER_URL;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private httpService: HttpService,
    private userService: UserService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastrService: ToastrService) {
    this.reactiveForm = this.fb.group({
      email: [{ value: '', disabled: true }],
      password: '',
      phone: '',
      firstName: '',
      lastName: '',
      role: [{ value: '', disabled: true }],
      // status: [{value: '', disabled: true}]
    });
  }


  ngOnInit(): void {
    // this.userService.currentUser.subscribe((res: any) => {
    //   this.companyId = res.company.id;
    // });
    // this.userService.currentUser.subscribe((r: any) => {
    //   console.log(r);
    //   this.user = r;
    // });
    this.user = this.data.user

    this.reactiveForm.patchValue({
      email: this.user.email,
      phone: this.user.phoneNumber,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      role: this.user.roles[0].id,
      // status: this.user.status

    });
  }

  editUser() {
    const fd = new FormData();
    if (this.reactiveForm.get('password').value) {
      fd.append('password', this.reactiveForm.get('password').value);
    }
    fd.append('firstName', this.reactiveForm.get('firstName').value);
    fd.append('lastName', this.reactiveForm.get('lastName').value);
    if (this.reactiveForm.get('phone').value !== this.user.phoneNumber) {
      fd.append('phoneNumber', this.reactiveForm.get('phone').value);
    }
    this.httpService.editUser(fd).subscribe((r: any) => {
      console.log(r);
      if (r.code === 1) {
        this.dialogRef.close(r.data);
        this.toastrService.success('User profile has been updated');
      } else {
        this.toastrService.warning('Failed to update user profile');
      }
      this.userService.getInfo()
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  chooseImage() {
    $('#img-upload').click();
  }


  fileSelect(e) {
    if (e.target.files[0].size > 1048576) {
      this.toastrService.error('Failed to update user avatar (max 1MB)');
      return
    }
    this.selectedFile = e.target.files[0];
    this.uploadAvatar()
  }

  uploadAvatar() {
    if (!this.selectedFile) {
      return;
    } else {
      const fd = new FormData();
      fd.append('id', this.user.id);
      fd.append('headerImage', this.selectedFile);
      this.httpService.editUser(fd).subscribe((r: any) => {
        console.log(r);
        if (r.code === 1) {
          this.user = r.data;
          this.user.idOrigin = this.userService.getIdOrigin(r.data.contacts, r.data.passwordContactItem.id);
          this.toastrService.success('User avatar has been updated. Please refresh page.');
          this.dialogRef.close(this.user);
        } else {
          this.toastrService.error('Failed to update user avatar');
        }

      });
    }

  }

}
